import { useQueries } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { DestinationFreightSummary } from "app/data/freights/model";

export const useInhouseSummary = (uniqueTerminals: any[]) => {

  const inhouseQueryConfigs = uniqueTerminals.map((terminal) => ({
    queryKey: [
      QUERY_KEYS.INHOUSE_SUMMARY,
      terminal.originTerminal,
      terminal.destinationTerminal,
    ],
    queryFn: async () => {
      const response = await apiQueryAdapter.query<DestinationFreightSummary[]>(
        "freight-at-dock/summary",
        "GET",
        {
          params: {
            originTerminal: terminal.originTerminal,
            destinationTerminal: terminal.destinationTerminal,
          },
        }
      );
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  }));


  const inhouseQueries = useQueries({
    queries: inhouseQueryConfigs,
  });

  const isFetchingInhouseSummary = inhouseQueries.some(q => q.isFetching);
  const isLoadingInhouseSummary = inhouseQueries.some(q => q.isLoading);
  const isErrorInhouseSummary = inhouseQueries.some(q => q.isError);
  const isAllSuccessInhouseSummary = inhouseQueries.every(q => q.isSuccess);

  return {
    inhouseQueries,
    isFetchingInhouseSummary,
    isLoadingInhouseSummary,
    isErrorInhouseSummary,
    isAllSuccessInhouseSummary,
  };
}